<template>
    <div class="list-container">
        <list-filters-basic
            @address-changed="value => (savedSearchAddress = value)"
            @add-filter="onBasicFilter"
            @clear-filters="clearPlace"
            @clear-filter="onClearFilter"
        />

        <loading-overlay
            class="loading-list"
            v-if="!isLoaded"
            :state="!isLoaded"
        ></loading-overlay>

        <template v-if="isLoaded">
            <div v-if="count > 0">
                <banner
                    :bannerText="
                        `${searchResultsText} - Create an account and purchase a 'Find Jobs' product to view the details!`
                    "
                    :cta="'Create Account'"
                    :redirect="'WorkforceRegister'"
                    v-if="!auth"
                />
                <banner
                    :bannerText="
                        `${searchResultsText} - Please purchase a 'Find Jobs' product to view the details!`
                    "
                    :cta="'Purchase Find Jobs'"
                    :redirect="'Account'"
                    v-if="
                        auth &&
                            user &&
                            !user.checkActiveFindJobsProduct() &&
                            !user.isSuperuser
                    "
                />
                <div class="list">
                    <b-overlay
                        :show="isProcessing"
                        class="align-items-center"
                        rounded="sm"
                        spinner-type="grow"
                        spinner-small
                    >
                        <b-container>
                            <b-row v-if="0 < list.length">
                                <b-col
                                    v-for="property in list"
                                    :key="`job_listing_${property.id}`"
                                    cols="12"
                                    sm="6"
                                    class="mb-4"
                                >
                                    <job-listing
                                        :id="property.id"
                                        :thumbnail="property.imageURL"
                                        :title="property.title"
                                        :description="property.description"
                                        :compensation="property.compensation"
                                        :city="property.city"
                                        :state="property.state"
                                        :preferedAreaId="property.preferedArea"
                                        @click:expand="
                                            () => gotoDetail(property.listingId)
                                        "
                                        @click="gotoProperty(property.listingId)"
                                    >
                                    </job-listing>
                                </b-col>
                            </b-row>
                            <no-data-placeholder v-else>
                                <template v-if="hasFilters" #sub
                                    >Please refine your search.</template
                                >
                            </no-data-placeholder>
                        </b-container>
                    </b-overlay>
                </div>
            </div>
            <b-container v-else class="py-5 text-gray-600 text-center">
                <b-row class="justify-content-center">
                    <b-col md="8" lg="6">
                        <no-data-placeholder>
                            <h1 class="mb-3 fs-2 fw-bold">
                                No Job Openings Found.
                            </h1>
                            <template #sub> </template>
                        </no-data-placeholder>
                    </b-col>
                </b-row>
            </b-container>
            <!--<b-modal
                size="md"
                class="centered"
                id="search-modal"
                :ok-disabled="searchString.length <= 0"
                @ok="saveSearch()"
                ok-title="Save"
            >
                <validation-observer ref="searchValidator">
                    <template #modal-title>Save search</template>
                    <div>
                        <t-input
                            input-classes="border rounded-pill"
                            name="search"
                            placeholder="Search Name"
                            v-model="searchString"
                        ></t-input>
                    </div>
                </validation-observer>
            </b-modal>-->
        </template>
        <!--<list-filters-modal :activeFilters="filters" />-->
        <runout-modal :list="true" :scope="this" />
        <b-modal
            v-if="this.auth && !this.user.checkActiveFindJobsProduct()"
            class="modal"
            id="find-jobs-subscription-modal"
            centered
            ok-title="Subscribe"
            variant="primary"
            @ok="redirect('Account')"
        >
            <template #modal-title>
                Workforce - Post job openings
            </template>
            <workforce-product-type :includeFindJobs="true" :includePostJobs="false" />
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Redirect from '@serv/Redirect'
import LoadingOverlay from '@comp/LoadingOverlay'
import ListFiltersBasic from '@comp/filters/JobListFiltersBasic'
//import ListFiltersModal from '@comp/ListFiltersModal'
import NoDataPlaceholder from '@comp/NoDataPlaceholder'
import JobService from '@serv/JobService'
import Banner from '@comp/Banner'
import RunoutModal from '@comp/modal/RunoutModal'
import JobListing from '@comp/listing/JobListing'
import ListMixin from '@mixins/ListMixin'
import NotifyService from '@serv/NotifyService'
import WorkforceProductType from '@comp/WorkforceProductType'

export default {
    name: 'JobList',
    metaInfo: 'Job Listings',
    components: {
        Banner,
        LoadingOverlay,
        ListFiltersBasic,
        //ListFiltersModal,
        RunoutModal,
        NoDataPlaceholder,
        JobListing,
        WorkforceProductType
    },
    mixins: [ListMixin],
    computed: {
        ...mapGetters(['user', 'auth']),
        ...mapGetters({
            searchQuery: 'jobSearchQuery',
            filtersQuery: 'jobFiltersQuery',
            filters: 'jobFilters',
            types: 'jobTypes'
        }),
        searchResultsText() {
            const listing = this.suffixIf(this.count > 1, 'Job opening', 's')

            return `${this.count} ${listing} on the platform `
        }
    },
    methods: {
        ...mapMutations({
            setTypes: 'setJobTypes',
            setSearchQuery: 'setJobSearchQuery',
            clearSearch: 'clearJobSearchQuery',
            clearFilters: 'clearJobFilters',
            removeListFilter: 'removeJobListFilter',
            addListFilter: 'addJobListFilter'
        }),
        getListings() {
            return JobService.getListings()
        },
        getListingsByQuery(query) {
            return JobService.getListingsByQuery(query)
        },
        postSearch(payload) {
            return JobService.postSearch(payload)
        },
        noResultNotify(notify) {
            return JobService.noResultNotify(notify)
        },
        goBack() {
            return Redirect.gotoName('SearchJob')
        },
        gotoDetail(listingId) {
            if (this.auth && this.user.checkActiveFindJobsProduct()) {
                this.$router.push({
                    name: 'JobDetail',
                    params: { id: listingId }
                })
            }
        },
        gotoProperty(listingId) {
            if (this.auth) {
                if (this.user.checkActiveFindJobsProduct()) {
                    this.$router.push({
                        name: 'JobDetail',
                        params: { id: listingId }
                    })
                } else {
                    /*else if (this.user.containsView) {
                    this.$bvModal.show('runout-modal-0')
                }*/
                    this.$bvModal.show('find-jobs-subscription-modal')
                }
            } else {
                NotifyService.confirm(
                    'Sign Up Required',
                    'You need an active account to continue.'
                ).then(rs => {
                    if ('confirm' !== rs) return
                    Redirect.gotoName('Register', null, { workforceSignUp: true })
                })
            }
        }
    },
    beforeMount() {},
    mounted() {},
    watch: {}
}
</script>
<style lang="scss" scoped>
@import './../../assets/sass/pages/_list.scss';
</style>
